module.exports = __webpack_public_path__ + "static/media/19ESCAP41.3367220b.jpg";